<template>
    <a-modal title="工单详情" width="60%" :open="true" :confirmLoading="state.loading" @cancel="
        () => {
            emit('cancel')
        }
    " :footer="false">
        <a-spin :spinning="allstate.zhuti_effect_loading" tip="正在更新平台方对该工单态度，请稍后...">
            <a-watermark :content="state.allperson" :gap="[200, 200]" fontWeight="light">
                <a-skeleton :loading="state.loading" active :paragraph="{ rows: 4 }">
                    <div class="p-1x">
                        <a-descriptions size="small" :column="2" :bordered="true">
                            <a-descriptions-item label="工单标题">
                                <div>{{ props.tableColumnsData.title }}&nbsp;</div>
                            </a-descriptions-item>
                            <a-descriptions-item label="关联主体：">
                                <div v-if="props.tableColumnsData.full_name"
                                    @click="goCustomerClick(props.tableColumnsData.full_name)" class="pointer">
                                    {{ props.tableColumnsData.full_name }}
                                </div>
                                <div v-if="props.tableColumnsData.full_address">
                                    {{ '入驻地址：' + (props.tableColumnsData.full_address ??
                                        props.tableColumnsData.registration_address) }}
                                </div>
                                <a-tag v-if="!props.tableColumnsData.full_name" color="green" class="mr-1x mb-1x"
                                    v-for="(item, index) in props.tableColumnsData.custodian_admin_info">
                                    {{ item.nickname }} {{ item.phone }}
                                </a-tag>
                            </a-descriptions-item>

                            <a-descriptions-item label="类型/状态">
                                <a-tag color="red" v-if="props.tableColumnsData.type == 1">投诉</a-tag>
                                <a-tag color="orange" v-else-if="props.tableColumnsData.type == 2">举报</a-tag>
                                <a-tag color="blue" v-else-if="props.tableColumnsData.type == 4">信函</a-tag>
                                <a-tag color="blue" v-else-if="props.tableColumnsData.type == 3">代办事项</a-tag>
                                <a-tag color="green" v-else>其他事项</a-tag>/
                                <a-tag color="green">{{
                                    props.tableColumnsData.status == 0
                                        ? '待处理'
                                        : props.tableColumnsData.status == 4
                                            ? '处理中'
                                            : props.tableColumnsData.status == 1
                                                ? '已办结'
                                                : props.tableColumnsData.status == 2
                                                    ? '已取消'
                                                    : '已删除'
                                }}</a-tag>
                            </a-descriptions-item>
                            <a-descriptions-item label="工单截止时间">
                                {{ props.tableColumnsData.start_time }} ~
                                {{ props.tableColumnsData.end_time }}
                            </a-descriptions-item>

                            <a-descriptions-item label="代理姓名">
                                <a-tag color="green" class="mr-1x mb-1x"
                                    v-for="(item, index) in props.tableColumnsData.reception_admin_info"> {{
                                        item.nickname }} {{ item.phone }} </a-tag>
                            </a-descriptions-item>

                            <a-descriptions-item label="执行负责人">
                                <a-tag color="green" class="mr-1x mb-1x"
                                    v-for="(item, index) in props.tableColumnsData.custodian_admin_info"> {{
                                        item.nickname }} {{ item.phone }} </a-tag>
                            </a-descriptions-item>
                            <a-descriptions-item label="涉及金额"
                                v-if="props.tableColumnsData.type == 1 || props.tableColumnsData.type == 2">
                                {{ props.tableColumnsData.tousu_money ? props.tableColumnsData.tousu_money + '元' : '无'
                                }}
                            </a-descriptions-item>
                            <a-descriptions-item label="投诉人姓名及电话"
                                v-if="props.tableColumnsData.type == 1 || props.tableColumnsData.type == 2">
                                {{ props.tableColumnsData.tousu_name }} {{ props.tableColumnsData.tousu_tel }}
                                <a v-if="props.tableColumnsData.tousu_tel"
                                    @click="onUsbphoneClick(props.tableColumnsData, props.tableColumnsData.tousu_tel)">
                                    <PhoneOutlined />
                                </a>
                            </a-descriptions-item>
                            <a-descriptions-item label="工单内容" :span="2" style="width: 105px">
                                <div>{{ props.tableColumnsData.content }}</div> <a
                                    v-if="props.tableColumnsData.wo_type == 13"
                                    @click="exportTaskBill(props.tableColumnsData)">下载账单
                                    <LoadingOutlined v-if="state.exportLoading" />
                                </a>
                                <a-button type="primary" size="small" v-else-if="props.tableColumnsData.wo_type == 14"
                                    @click="openPayCenter">支付差额</a-button>
                            </a-descriptions-item>

                            <a-descriptions-item label="工单附件" :span="2">
                                <span v-for="(item, index) in props.tableColumnsData.attachment">
                                    <a-image
                                        v-if="item.name.indexOf('jpg') > -1 || item.name.indexOf('png') > -1 || item.name.indexOf('jpeg') > -1"
                                        :key="index" :width="100" :height="100"
                                        :src="$store.state.user.image_domain + item.url">
                                    </a-image>
                                    <a v-else :href="$store.state.user.image_domain_a + item.url" download
                                        target="_blank">{{ item.name }}</a>
                                </span>
                            </a-descriptions-item>
                            <a-descriptions-item label="最新动态" :span="2">
                                <div class="mv-2x" v-if="state.work_order_chat?.length > 0"
                                    style="width: 35%; float: left">
                                    <div style="height: 6px"></div>
                                    <a-timeline class="timelineStatus">
                                        <a-timeline-item color="green" v-for="(item, index) in state.work_order_chat"
                                            :key="index">
                                            <p>{{ item.after_status_name }} {{ item.created_at }}</p>
                                            <p v-html="item.msg"></p>
                                            <template v-if="item.is_read == 0">
                                                <a-badge :dot="true"></a-badge>
                                            </template>
                                            <div v-if="item.attachment">
                                                <span v-for="(item, index) in item.attachment">
                                                    <a-image
                                                        v-if="item.name.indexOf('jpg') > -1 || item.name.indexOf('png') > -1 || item.name.indexOf('jpeg') > -1"
                                                        :key="index" :width="120" :height="50"
                                                        :src="$store.state.user.image_domain + item.url">
                                                    </a-image>
                                                    <p v-else>
                                                        <a :href="$store.state.user.image_domain + item.url"
                                                            target="_blank">{{ item.name }}</a>
                                                    </p>
                                                </span>
                                            </div>
                                            <p>发送人：{{ item.send_info.nickname }}</p>
                                        </a-timeline-item>
                                    </a-timeline>
                                </div>
                                <a-empty v-if="state.work_order_chat?.length == 0" description="暂无微信沟通"
                                    class="flex-center flex-dc" />
                                <div style="width: 65%; float: left" class="mv-2x">
                                    <a-form ref="formRef" v-bind="formLayout">
                                        <a-form-item label="附件上传">
                                            <Upload
                                                :upload_path="`public/uploads/manage/工单/${dayjs().format('YYYYMM')}/`"
                                                :accept="['pdf', 'doc', 'docx', 'xls', 'xlsx', 'jpeg', 'jpg', 'png']"
                                                v-model:value="state.attachment" uploadType="text" :limitation="9"
                                                uploadText="上传附件">
                                            </Upload>
                                        </a-form-item>
                                        <a-form-item label="发布内容">
                                            <div style="display: flex; margin-bottom: 10px">
                                                <a-textarea v-model:value="state.content" placeholder="请输入发布内容"
                                                    :auto-size="{ minRows: 2, maxRows: 10 }" />
                                                <a-popconfirm title="确定发布吗?" @confirm="submit">
                                                    <a-button class="ml-1x" type="primary"
                                                        :loading="state.fbloading">发布</a-button>
                                                </a-popconfirm>
                                            </div>
                                        </a-form-item>
                                        <a-form-item label="主体影响" style="margin-top: 10px; margin-bottom: 50px"
                                            required>
                                            <a-radio-group v-model:value="props.tableColumnsData.zhuti_effect"
                                                button-style="solid" @change="change_zhuti_effect">
                                                <a-radio-button :value="1">消极影响</a-radio-button>
                                                <a-radio-button :value="2">不影响</a-radio-button>
                                            </a-radio-group>
                                        </a-form-item>
                                        <a-form-item :wrapper-col="{ span: 18, offset: 7 }">
                                            <a-popconfirm title="确定办结此工单?" @confirm="changeStatus(1)">
                                                <a-button class="mr-1x" type="primary"
                                                    :loading="state.statusLoading === 1">办结工单</a-button>
                                            </a-popconfirm>

                                            <a-popconfirm title="确定取消此工单?" @confirm="changeStatus(2)">
                                                <a-button class="mr-1x" type="primary"
                                                    :loading="state.statusLoading === 2">取消工单</a-button>
                                            </a-popconfirm>

                                            <a-popconfirm title="确定转为恢复待处理?" @confirm="changeStatus(0)">
                                                <a-button class="mr-1x" type="primary"
                                                    :loading="state.statusLoading === 0">恢复待处理</a-button>
                                            </a-popconfirm>
                                            <a-popconfirm title="确定为转为久悬工单吗?" @confirm="changeStatus(5)">
                                                <a-button class="mr-1x" type="primary" style="background: #000"
                                                    :loading="state.statusLoading === 5">转为久悬工单</a-button>
                                            </a-popconfirm>
                                        </a-form-item>
                                        <!-- 如果以办结，可以核实一下 -->
                                        <div
                                            v-if="props.tableColumnsData.status == 1 || props.tableColumnsData.status == 5">
                                            <a-divider
                                                style="border-color: #f0f0f0; margin: 20px 0;">以下是平台管理员核实专属功能区</a-divider>
                                            <a-form-item label="核实备注">
                                                <a-textarea v-model:value="state.verifyRemark" placeholder="请输入核实备注"
                                                    :auto-size="{ minRows: 2, maxRows: 10 }" />
                                            </a-form-item>
                                            <a-form-item :wrapper-col="{ span: 18, offset: 7 }"
                                                v-if="state.user_permission == 'admin' || state.user_permission == 'platform'">
                                                <a-popconfirm title="确定核实通过此工单吗?" @confirm="() => handleVerify('pass')">
                                                    <a-button class="mr-1x" type="primary"
                                                        :loading="state.verifyLoading === 'pass'">核实通过</a-button>
                                                </a-popconfirm>

                                                <a-popconfirm title="确定重新处理此工单吗?"
                                                    @confirm="() => handleVerify('reprocess')">
                                                    <a-button class="mr-1x" type="primary"
                                                        :loading="state.verifyLoading === 'reprocess'">重新处理</a-button>
                                                </a-popconfirm>
                                            </a-form-item>
                                        </div>
                                    </a-form>
                                </div>
                            </a-descriptions-item>
                        </a-descriptions>

                        <!-- <a-button class="mr-1x" type="primary" @click="changeStatus(1)">办结工单</a-button>
        <a-button class="mr-1x" type="primary" @click="changeStatus(2)">取消工单</a-button> -->
                        <!-- <a-button class="mr-1x" @click="onTransferOrderClick" type="primary">转单</a-button> -->
                        <transfer-order v-if="state.transferOrderVisible" ref="transferOrderRef" @cancel="
                            () => {
                                state.transferOrderVisible = false
                            }
                        "></transfer-order>
                    </div>
                </a-skeleton>
            </a-watermark>
        </a-spin>
        <PayCenter :tableColumnsData="state.custData" v-if="state.addressRenewVisible" @cancel="handleCancel"
            @ok="handleOk" ref="payCenterRef">
        </PayCenter>
    </a-modal>
</template>

<script lang="ts" setup>
import cloneDeep from 'lodash.clonedeep'
import { LoadingOutlined, PhoneOutlined } from '@ant-design/icons-vue'
import transferOrder from './transferOrder.vue'
import { ref, reactive, onMounted, nextTick } from 'vue'
import { message } from 'ant-design-vue'
import { useStore } from 'vuex'
import Upload from '@/components/base/Upload.vue'
import PayCenter from '../../customer/components/PayCenter.vue'
const $store = useStore()
import baseService from '@/utils/http/axios'
import dayjs from 'dayjs'
import { useRouter } from 'vue-router'
import { action } from '@logicflow/core/types/util/mobx'
import { stat } from 'fs'
const router = useRouter()
const props = defineProps({
    tableColumnsData: {
        type: Object,
        default: () => null
    }
})
const formLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
    }
}

onMounted(() => {
    queryDetail()
})
const formRef = ref()
const emit = defineEmits(['cancel', 'ok'])
const state = reactive<any>({
    transferOrderVisible: false,
    loading: false,
    fbloading: false,
    content: null,
    attachment: [],
    // 上传文件
    fileList: [],
    detailData: {},
    fileInformation: [],
    work_order_chat: [],
    allperson: '',
    exportLoading: false,
    verifyRemark: '', // 核实备注
    statusLoading: null, // 状态按钮loading: 0,1,2,5
    verifyLoading: null, // 核实按钮loading: 'pass', 'reprocess'
    user_permission: 'seller',
    addressRenewVisible: false,
    custData: {}
})
const goCustomerClick = (name) => {
    emit('cancel')
    router.push({ path: '/customer', query: { customer_name: name, tabsKey: 2 } })
}
const allstate = reactive<any>({
    zhuti_effect_loading: false
})
const change_zhuti_effect = () => {
    allstate.zhuti_effect_loading = true
    let requestParam = {
        url: '/admin/v1/workOrder/changeZhutiEffect',
        method: 'post',
        data: {
            id: props.tableColumnsData.id,
            zhuti_effect: props.tableColumnsData.zhuti_effect
        }
    }
    baseService(requestParam)
        .then((res) => {
            allstate.zhuti_effect_loading = false
            message.success(res.msg ? res.msg : '操作成功')
        })
        .catch((res) => {
            allstate.zhuti_effect_loading = false
        })
}
const queryDetail = () => {
    state.loading = true
    let requestParam = {
        url: `/admin/v1/workOrderChatLog?id=` + props.tableColumnsData.id,
        method: 'get'
    }
    baseService(requestParam)
        .then((res) => {
            state.loading = false
            state.work_order_chat = res.data.work_order_chat
            state.user_permission = res.data.user_permission
            state.allperson = allperson(props.tableColumnsData.reception_admin_info)
        })
        .catch((res) => {
            state.loading = false
        })
}
const allperson = (p) => {
    let text = ''
    for (let itemindex in p) {
        text += p[itemindex].nickname + '&&'
    }
    return text.substring(0, text.length - 2)
}
const onTransferOrderOk = () => {
    state.transferOrderVisible = false
    emit('ok')
}

const changeStatus = (type) => {
    if ([1, 5].includes(type) && props.tableColumnsData.zhuti_effect == 0) {
        message.error('请选择"主体影响"后再办结此工单！')
        return false
    }
    state.statusLoading = type
    let requestParam = {
        url: '/admin/v1/workOrder/changeStatus',
        method: 'post',
        data: {
            id: props.tableColumnsData.id,
            status: type
        }
    }
    baseService(requestParam)
        .then((res) => {
            message.success(res.msg ? res.msg : '操作成功')
            state.statusLoading = null
            emit('ok')
        })
        .catch((res) => {
            message.error(res.msg ? res.msg : '操作失败')
            state.statusLoading = null
        })
}

const submit = () => {
    state.fbloading = true
    if (!state.content && !state.attachment) {
        message.error('回复内容或附件不能为空')
        state.fbloading = false
        return
    }
    let requestParam = {
        url: '/admin/v1/workOrder/reply',
        method: 'post',
        data: {
            work_order_id: props.tableColumnsData.id,
            msg: state.content,
            attachment: state.attachment
        }
    }
    baseService(requestParam)
        .then((res) => {
            state.fbloading = false
            message.success(res.msg ? res.msg : '操作成功')
            state.content = null
            state.attachment = []
            queryDetail()
        })
        .catch((res) => {
            state.fbloading = false
            message.error(res.msg ? res.msg : '操作失败')
        })
}
const onTransferOrderClick = () => {
    state.transferOrderVisible = true
}
// 计划任务-下载账单
const exportTaskBill = (record) => {
    let snarr = record.sn.split("#");
    let type = snarr[0]
    if (type == 'gengcaiFreeZhang') {
        //耿才免费送章
        let month = snarr[1]
        let queryParam = {
            between_time: monthToBetween_time(month),
            action: ['kezhang'],
            coupon_id: 21
        }
        state.exportLoading = true
        let requestParam = {
            url: '/admin/v1/orders/export',
            method: 'post',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                responseType: 'blob'
            },
            data: Object.assign({ type: 2, limit: 'all', page: 1, version: 'admin', hideSeller: 1 }, queryParam)
        }
        baseService(requestParam)
            .then((res) => {
                message.success('下载成功')
            })
            .catch((res) => {
                state.exportLoading = false
                if (res.msg) {
                    message.error(res.msg)
                } else {
                    message.error('下载失败')
                }
            }).finally(() => {
                state.exportLoading = false
            })
    } else if (type == 'wawajiaoServiceFee') {
        //哇哇叫服务费
        let month = snarr[1]
        let queryParam = {
            between_time: monthToBetween_time(month),
            action: ['kezhang']
        }
        state.exportLoading = true
        let requestParam = {
            url: '/admin/v1/orders/export',
            method: 'post',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                responseType: 'blob'
            },
            data: Object.assign({ type: 2, limit: 'all', page: 1, version: 'admin', hideSeller: 1 }, queryParam)
        }
        baseService(requestParam)
            .then((res) => {
                message.success('下载成功')
            })
            .catch((res) => {
                state.exportLoading = false
                if (res.msg) {
                    message.error(res.msg)
                } else {
                    message.error('下载失败')
                }
            }).finally(() => {
                state.exportLoading = false
            })
    } else if (type == 'kaifu2302ServiceFee') {
        //开福区2302的服务商共计
        let month = snarr[1]
        let queryParam = {
            between_time: monthToBetween_time(month),
            platform_id: [15],
            action: ['custRegister', 'custRenewal', 'custOther']
        }
        state.exportLoading = true
        let requestParam = {
            url: '/admin/v1/orders/export',
            method: 'post',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                responseType: 'blob'
            },
            data: Object.assign({ type: 2, limit: 'all', page: 1, version: 'admin', hideSeller: 1 }, queryParam)
        }
        baseService(requestParam)
            .then((res) => {
                message.success('下载成功')
            })
            .catch((res) => {
                state.exportLoading = false
                if (res.msg) {
                    message.error(res.msg)
                } else {
                    message.error('下载失败')
                }
            }).finally(() => {
                state.exportLoading = false
            })
    } else if (type == 'wajieServiceFee') {
        //万捷孵化器佣金：万捷、万捷分公司、万多、万永、多尚
        let month = snarr[1]
        let queryParam = {
            between_time: monthToBetween_time(month),
            platform_id: [1, 2, 3, 9, 11],
            action: ['custRegister', 'custRenewal', 'custOther']
        }
        state.exportLoading = true
        let requestParam = {
            url: '/admin/v1/orders/export',
            method: 'post',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                responseType: 'blob'
            },
            data: Object.assign({ type: 2, limit: 'all', page: 1, version: 'admin', hideSeller: 1 }, queryParam)
        }
        baseService(requestParam)
            .then((res) => {
                message.success('下载成功')
            })
            .catch((res) => {
                state.exportLoading = false
                if (res.msg) {
                    message.error(res.msg)
                } else {
                    message.error('下载失败')
                }
            }).finally(() => {
                state.exportLoading = false
            })
    } else if (type == 'duoyouServiceFee') {
        //多友，洞井
        let month = snarr[1]
        let queryParam = {
            between_time: monthToBetween_time(month),
            platform_id: [14],
            action: ['custRegister', 'custRenewal', 'custOther']
        }
        state.exportLoading = true
        let requestParam = {
            url: '/admin/v1/orders/export',
            method: 'post',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                responseType: 'blob'
            },
            data: Object.assign({ type: 2, limit: 'all', page: 1, version: 'admin', hideSeller: 1 }, queryParam)
        }
        baseService(requestParam)
            .then((res) => {
                message.success('下载成功')
            })
            .catch((res) => {
                state.exportLoading = false
                if (res.msg) {
                    message.error(res.msg)
                } else {
                    message.error('下载失败')
                }
            }).finally(() => {
                state.exportLoading = false
            })
    } else if (type == 'gengcaiServiceFee') {
        //耿才
        let month = snarr[1]
        let queryParam = {
            between_time: monthToBetween_time(month),
            platform_id: [36],
            action: ['custRegister', 'custRenewal', 'custOther']
        }
        state.exportLoading = true
        let requestParam = {
            url: '/admin/v1/orders/export',
            method: 'post',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                responseType: 'blob'
            },
            data: Object.assign({ type: 2, limit: 'all', page: 1, version: 'admin', hideSeller: 1 }, queryParam)
        }
        baseService(requestParam)
            .then((res) => {
                message.success('下载成功')
            })
            .catch((res) => {
                state.exportLoading = false
                if (res.msg) {
                    message.error(res.msg)
                } else {
                    message.error('下载失败')
                }
            }).finally(() => {
                state.exportLoading = false
            })
    } else {
        message.error('暂不支持下载')
    }
}
//辅助函数将202601 转换
const monthToBetween_time = (month) => {
    // 解析年月
    const year = month.slice(0, 4);
    const monthStr = month.slice(4); // "01"

    // 直接拼接开始时间
    const startStr = `${year}-${monthStr}-01 00:00:00`;

    // 计算结束时间
    const lastDay = new Date(year, parseInt(monthStr), 0).getDate();
    const endStr = `${year}-${monthStr}-${lastDay.toString().padStart(2, '0')} 23:59:59`;
    return [startStr, endStr];
}
const onUsbphoneClick = (record, phone) => {
    console.log(record)
    $store.dispatch('usbphone/AddPhoneModal', {
        phone: phone,
        customer_id: record.customer_id,
        full_name: record.title
    })
}
const handleVerify = (type: string): void => {
    if (!state.verifyRemark) {
        message.error('请填写核实备注')
        return
    }

    state.verifyLoading = type
    let requestParam = {
        url: '/admin/v1/workOrder/verify',
        method: 'post',
        data: {
            id: props.tableColumnsData.id,
            type: type,
            verify_remark: state.verifyRemark
        }
    }

    baseService(requestParam)
        .then((res) => {
            let tipMsg = type === 'pass' ? '核实通过成功' : '重新处理成功'
            message.success(res.data?.msg ? res.data.msg : tipMsg)
            state.verifyRemark = ''
            state.verifyLoading = null
            emit('ok')
        })
        .catch((res) => {
            message.error(res.data?.msg ? res.data.msg : '操作失败')
            state.verifyLoading = null
        })
}
const payCenterRef = ref(null)
const openPayCenter = () => {
    state.loading = true
    let requestParam = {
        url: '/admin/v1/customerList',
        method: 'post',
        data: Object.assign({ page: 1, limit: 1 }, { address_number: props.tableColumnsData.full_address, nameOrCode: props.tableColumnsData.full_name })
    }
    baseService(requestParam)
        .then((res: any) => {
            if (res.data.list.length > 0) {
                state.custData = res.data.list[0]
                state.addressRenewVisible = true
                nextTick(() => {
                    payCenterRef.value?.initPage('小规模转一般纳税人')
                })
            } else {
                message.error('未查询到客户信息')
            }
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败,请联系管理员')
            }
        })
        .finally(() => {
            state.loading = false
        })
}
const handleCancel = () => {
    state.addressRenewVisible = false
}
const handleOk = () => {
    state.addressRenewVisible = true
}
</script>

<style lang="less" scoped>
.ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
}

.add-button {
    position: absolute;
    right: 65px;
    top: 10px;
}

.positionItem {
    display: inline-block;
    margin-bottom: 10px;
}

.timelineStatus {
    .ant-timeline-item:last-child {
        p:first-child {
            color: #ff5000;
        }
    }
}
</style>
